
/**
 * Add classe 'children-input-has-value' to parent Elements
 * Add classe 'children-input-has-focus' to parent Elements
 * 
 */


// on input
 document.addEventListener('input', function(e){

    if(!e.target.closest('input, textarea ')) return

    var input = e.target;

    if(input.value) {
        input.parentElement.classList.add('filled');
    } else {
        input.parentElement.classList.remove('filled');
    }

}, true);


// on blur
document.addEventListener('blur', function(e){


    if(!e.target.closest('input, textarea')) return

    var input = e.target;

    input.parentElement.classList.remove('active')

}, true);

// on focus
document.addEventListener('focus', function(e){

    if(!e.target.closest('input, textarea ')) return

    var input = e.target;

    input.parentElement.classList.add('active')

}, true);
